import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoalRoutingModule } from './goal-routing.module';
import { GoalsComponent } from './components/goals/goals.component';
import { GtapMaterialsModule } from '../gtap-materials/gtap-materials.module';
import { EffectsModule } from '@ngrx/effects';
import { GoalEffects } from '../store/goal/goal.effects';
import { StoreModule } from '@ngrx/store';
import * as fromGoal from '../store/goal/goal.reducer';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import { GoalDisplayComponent } from './components/goal-display/goal-display.component';
import { GoalStepDisplayComponent } from './components/goal-step-display/goal-step-display.component';

@NgModule({
  declarations: [GoalsComponent, GoalDisplayComponent, GoalStepDisplayComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    GtapMaterialsModule,
    GoalRoutingModule,
    StoreModule.forFeature(fromGoal.goalFeatureKey, fromGoal.reducer),
    EffectsModule.forFeature([GoalEffects]),
  ]
})
export class GoalModule {}
